import React, { useRef } from 'react';
import { SVG } from '../../../components/atoms/SVG/';
import { Icons } from '../../../components/atoms/SVG';
import { Tooltip } from '../../../components/atoms/Tooltip';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import bem from '../../../lib/bemUtils/bem';
import { Parameter } from '../../../_lib/Form2/types/SonForm';
import { ReactionType } from '../PageInstantReaction.types';

export type ReactionButtonParam = Parameter<'button', string, ReactionType> & { value: ReactionType; checked: boolean };

type ReactionConfig = {
  icon: (typeof Icons)[keyof typeof Icons];
};

const ICON_CONFIG: Record<ReactionType, ReactionConfig> = {
  like: { icon: Icons.THUMB_LIKE },
  approval: { icon: Icons.APPROVAL },
  valuable: { icon: Icons.VALUABLE },
  interesting: { icon: Icons.LIGHTBULB },
};

export type PageInstantReactionButtonProps = ReactionButtonParam;

export function PageInstantReactionButton({ name, value, checked }: PageInstantReactionButtonProps) {
  const { t } = useSonTranslation('PageInstantReaction');
  const buttonRef = useRef<HTMLButtonElement | null>(null);
  const config = ICON_CONFIG[value];
  const text = checked ? t(`reverseReactions.${value}`) : t(`reactions.${value}`);
  const buttonClass = bem('page-instant-reaction__button', [value]);

  return (
    <Tooltip attachTo={buttonRef}>
      <button
        ref={buttonRef}
        type="submit"
        name={name}
        value={value}
        className={buttonClass}
        title={text}
        aria-label={text}
        aria-pressed={checked}
      >
        <span className="page-instant-reaction__button-icon">
          <SVG svgSpriteId={config.icon} />
        </span>
      </button>
    </Tooltip>
  );
}
